import { Component, Inject, ViewEncapsulation } from '@angular/core';

import { Events, EventBusService } from '../../../technical-modules/events/services/event-bus.service';

import { OngoingBatchService } from '../services/ongoing-batchs.service';
import { OngoingBatchDto } from '../entities/ongoing-batch-dto.entity';

type KeyValue = {
	[key: string]: string
};

type BatchDisplay = {
	batch: OngoingBatchDto,
	creationDate: Date,
}

@Component({
	selector: 'batchs-monitor',
	templateUrl: 'batchs-monitor.html',
	styleUrls: ['batchs-monitor.css'],
	// Desactivation de l'encapsulation, pour eviter un bug preventant le styling du Material Menu
	encapsulation: ViewEncapsulation.None,
})
export class BatchsMonitorComponent {
	display: boolean = false;
	iconColor: string = 'black';
	batchsCount: number = 0;
	batchsDisplays: BatchDisplay[] = [];
	
	// Correpsondances pour les status des jobs
	statusColor: KeyValue = {
		'COMPLETED': 'green',
		'EXECUTING': 'black',
		'FAILED': 'red',
	};
	statusLabel: KeyValue = {
		'COMPLETED': 'terminé',
		'EXECUTING': 'en cours',
		'FAILED': 'échoué',
	};
	private statusPriority = [
		'FAILED',
		'COMPLETED',
		'EXECUTING',
	]

	constructor(
		@Inject(EventBusService) private eventBusService: EventBusService, //
		@Inject(OngoingBatchService) private ongoingBatchsService: OngoingBatchService,
	) {
		// Observer les changements sur les batchs de l'utilisateur
		let batchs$ = ongoingBatchsService.observeBatchsForUser();
		batchs$.subscribe((batchs) => {
			// Traitement de certains cas de status particuliers a interpreter comme un equivalant de 'EXECUTING"
			batchs
				.filter($ => $.status === 'STARTING' || $.status === 'STARTED')
				.forEach($ => $.status = 'EXECUTING')
			;

			// Alimenter la vue avec les batchs a afficher
			this.batchsDisplays = batchs.map($ => ({
				batch: $,
				creationDate: new Date($.creationTimestamp)
			} as BatchDisplay));

			// Actualisation du bouton avec les dernieres donnees
			this.display = batchs.length > 0;
			let status = this.statusPriority.find(status => batchs.findIndex(batch=> batch.status === status) >= 0);
			if (!status) {
				status = "EXECUTING";
			}
			this.iconColor = this.statusColor[status];
			this.batchsCount = batchs.filter($ => $.status === status).length;
		});
	}
	
	onBatchRemoveClicked(batch: OngoingBatchDto) {
		this.clearBatchs([batch.jobExecutionId]);
	}
	
	onClearClicked() {
		let ids = this.batchsDisplays
			.map($ => $.batch)
			.filter($ => {
				let status = $.status;
				return status === "COMPLETED" || status === "FAILED";
			})
			.map($ => $.jobExecutionId)
		;
		
		this.clearBatchs(ids);
	}
	
	private clearBatchs(ids: number[]) {
		this.ongoingBatchsService.clear(ids).subscribe({
			next: () => {
				// A la reception d'un clear, il faut recharger les batchs
				this.eventBusService.emit(Events.RefreshBatchIndicatorRequested, null);
			},
			error: (_error) => {
				alert("Le serveur a rencotré un erreur imprévue");
			},
		});
	}
}